import { Component, Input, OnInit } from '@angular/core';
import { Datastore } from '@freelancer/datastore';
import {
  SkillsSubNavigation,
  SkillsSubNavigationCollection,
} from '@freelancer/datastore/collections';
import { Margin } from '@freelancer/ui/margin';
import { FontWeight } from '@freelancer/ui/text';
import * as Rx from 'rxjs';

@Component({
  selector: 'app-navigation-secondary-skills',
  template: `
    <fl-bit class="NavigationSecondarySkills">
      <fl-container class="NavigationSecondarySkills-items">
        <fl-text
          i18n="Explore skills navigation label"
          [weight]="FontWeight.BOLD"
          [flMarginRight]="Margin.XXLARGE"
        >
          EXPLORE
        </fl-text>

        <ng-container *ngIf="skillsSubNav$ | flAsync as skillsSubNav">
          <app-navigation-secondary-skills-nav-item
            *ngFor="let item of skillsSubNav.links"
            [navItem]="item"
            [flMarginRight]="Margin.MID"
          ></app-navigation-secondary-skills-nav-item>
        </ng-container>
      </fl-container>
    </fl-bit>
  `,
  styleUrls: ['./navigation-secondary-skills.component.scss'],
})
export class NavigationSecondarySkillsComponent implements OnInit {
  FontWeight = FontWeight;
  Margin = Margin;

  skillsSubNav$: Rx.Observable<SkillsSubNavigation>;

  @Input() userId$: Rx.Observable<number>;

  constructor(private datastore: Datastore) {}

  ngOnInit(): void {
    this.skillsSubNav$ = this.datastore
      .document<SkillsSubNavigationCollection>(
        'skillsSubNavigation',
        this.userId$,
      )
      .valueChanges();
  }
}
